<div
  class="tabWrappy"
  [@resizeAnimation]="(!(selectedTranche | async) || false).toString()"
>
  <div class="filter-label" *ngIf="!!(filterItemGroups | async)">
    <muni-gameday-filter-label
      [allLabel]="allLabel | async"
      [highlightAll]="highlightAll | async"
      [labelGenerator]="labelGenerator | async"
      [showingLabel]="showingLabel | async"
      [itemGroups]="filterItemGroups | async"
      [values]="filterValues | async"
      [isSoleManagedDeal]="isSoleManagedDeal | async"
      (filterChange)="onFilterChange($event)"
    >
    </muni-gameday-filter-label>
  </div>
  <muni-gameday-tabbed-panel
    [condensed]="true"
    [reactOnChange]="true"
    [activeTab]="activeTab"
    [subscribeOnChange]="true"
    (changed)="onTabChange($event)"
  >
    <muni-gameday-tab header="Overview">
      <muni-gameday-loading [visible]="loading | async">
        <muni-gameday-monitor-overview-page
          [dataSource]="overviewPageData | async"
          (maturityClick)="selectMaturity($event)"
          data-automation-e2e-selector="overviewTabContainer"
        >
        </muni-gameday-monitor-overview-page>
      </muni-gameday-loading>
    </muni-gameday-tab>
    <muni-gameday-tab
      muniGamedayTooltip
      header="Retail"
      [tooltip]="getRetailTabTooltipText(isRetailTabDisabled | async)"
      [disabled]="isRetailTabDisabled | async"
    >
      <muni-gameday-loading [visible]="loading | async">
        <muni-gameday-monitor-retail-page
          [dataSource]="retailPageData | async"
          (maturityClick)="selectMaturity($event)"
          (disable)="disable($event)"
          data-automation-e2e-selector="retailTabContainer"
        >
        </muni-gameday-monitor-retail-page>
      </muni-gameday-loading>
    </muni-gameday-tab>
    <muni-gameday-tab
      muniGamedayTooltip
      header="Priority"
      [tooltip]="getPriorityTabTooltipText(isSoleManagedDeal | async)"
      [disabled]="isSoleManagedDeal | async"
    >
      <muni-gameday-loading [visible]="loading | async">
        <muni-gameday-monitor-priority-page
          [dataSource]="priorityPageData | async"
          (maturityClick)="selectMaturity($event)"
          data-automation-e2e-selector="priorityTabContainer"
        >
        </muni-gameday-monitor-priority-page>
      </muni-gameday-loading>
    </muni-gameday-tab>
  </muni-gameday-tabbed-panel>
</div>

<div
  class="tranche-details-wrapper"
  [@enterAnimation]="(!!(selectedTranche | async) || false).toString()"
>
  <muni-gameday-tranche-details
    [tranche]="selectedTranche | async"
    [viewType]="gameDayViewType | async"
    [showCloseButton]="true"
    (closeDetails)="selectMaturity(undefined)"
  >
  </muni-gameday-tranche-details>
</div>
